import React from 'react';
import { Grid, AppBar, CssBaseline, Toolbar, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LogoutBtn from '../logoutBtn';
import { useAppHeaderStyles } from './style';
import NavDropdown from '../navDropdown/navDropdown';
import { PersonRole } from '../../models/eums/personRole';
import { personHasRole } from '../../utils/personUtils';
import ZTSHLogo from '../../images/ztsh-logo.png';

export function AppHeader() {
  const appHeaderStyles = useAppHeaderStyles();
  const { t } = useTranslation();

  return (
    <>
      <CssBaseline />
      <AppBar id='officiating-app-bar' color='default' className={appHeaderStyles.appBar}>
        <Toolbar>
          <Grid
            container
            wrap='nowrap'
            direction='row'
            justify='space-between'
            alignItems='center'
            spacing={1}
          >
            <Grid
              item
              container
              sm={2}
              md={3}
              lg={2}
              direction='row'
              spacing={1}
              alignItems='center'
              component={Link}
              to='/'
              style={{ textDecoration: 'none' }}
            >
              <Grid item>
                <img src={ZTSHLogo} className={appHeaderStyles.logo} alt='ZTSH logo' />
              </Grid>
              <Grid item>
                <Typography variant='h6' color='inherit' noWrap>
                  {t('officiating')}
                </Typography>
              </Grid>
            </Grid>

            <Grid container item sm={9} md={8} lg={6}>
              <Grid item>
                <Button component={Link} to='/my-profile'>
                  {t('my_profile')}
                </Button>
              </Grid>
              <Grid item>
                <NavDropdown
                  title={t('evaluations')}
                  popperPosition='bottom-start'
                  options={[
                    {
                      itemName: t('my_evaluations'),
                      route: '/evaluations-evaluator',
                    },
                    {
                      itemName: t('by_others'),
                      route: '/evaluations-evaluee',
                    },
                    {
                      itemName: t('create_evaluation'),
                      route: '/evaluation/create',
                    },
                    {
                      itemName: t('evaluation_templates'),
                      route: '/evaluation-templates',
                    },
                    {
                      itemName: t('create_evaluation_template'),
                      route: '/evaluation-templates/create',
                      userRoles: [PersonRole.Admin],
                    },
                  ]}
                />
              </Grid>
              <Grid item>
                <NavDropdown
                  title={t('tournaments')}
                  popperPosition='bottom-start'
                  options={[
                    {
                      itemName: t('my_tournaments'),
                      route: '/my-tournaments',
                    },
                    {
                      itemName: t('tournament_calendar'),
                      route: '/tournament-calendar',
                    },
                  ]}
                />
              </Grid>
              <Grid item>
                <Button component={Link} to='/officials'>
                  {t('officials')}
                </Button>
              </Grid>
              <Grid item>
                <Button component={Link} to='/about'>
                  {t('about')}
                </Button>
              </Grid>
              {personHasRole(PersonRole.Admin) && (
                <Grid item xs>
                  <NavDropdown
                    title={t('administrator')}
                    popperPosition='bottom-start'
                    options={[
                      {
                        itemName: t('invite_user'),
                        route: '/admin/invite-user',
                        userRoles: [PersonRole.Admin],
                      },
                    ]}
                  />
                </Grid>
              )}
            </Grid>
            <Grid item sm={1} style={{ textAlign: 'right' }}>
              <LogoutBtn />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
}
